type IArquivos = {
    arquivo: any;
    nome: string;
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos: IArquivos[];
};
type TItem = {
    title: string;
    materiais: IMaterial[];
};

export const ListMateriaisCircuitoPrivateApoioCultural: TItem[] = [
    {
        title: 'Materiais Formativos',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Agendas Formativas',
                arquivos: [
                    {
                        nome: 'Ciclo_1_agenda_formativa_Circuito_360_digital_ApoioCultural',
                        arquivo: 'Materiais/Ciclo_1_agenda_formativa_Circuito_360_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'Ciclo_2_agenda_formativa_Circuito_360_digital_ApoioCultural',
                        arquivo: 'Materiais/Ciclo_2_agenda_formativa_Circuito360_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'Ciclo_3_agenda_formativa_Circuito_360_digital_ApoioCultural',
                        arquivo: 'Materiais/Ciclo_3_agenda_formativa_Circuito_360_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'Ciclo_4_agenda_formativa_Circuito_360_digital_ApoioCultural',
                        arquivo: 'Materiais/Ciclo_4_agenda_formativa_Circuito_360_digital_ApoioCultural.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Ciclos Formativos',
                arquivos: [
                    {
                        nome: 'PPT_Circuito_360_Ciclo_1_DIA_1_ApoioCultural',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_1_DIA_1_ApoioCultural.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_1_DIA_2_ApoioCultural',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_1_DIA_2_ApoioCultural.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_2_DIA_1_ApoioCultural',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_2_DIA_1_ApoioCultural.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_2_DIA_2_ApoioCultural',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_2_DIA_2_ApoioCultural.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_3_DIA_1_ApoioCultural',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_3_DIA_1_ApoioCultural.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_3_DIA_2_ApoioCultural',
                        arquivo: 'anexo_storage_files_17255509961849040143.pptx_2025-04-29-1745951536279.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_4_DIA_1_ApoioCultural',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_4_DIA_1_ApoioCultural.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_4_DIA_2_ApoioCultural',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_4_DIA_2_ApoioCultural.pptx',
                    },
                ],
            },
        ],
    },
    {
        title: 'Atividades Integradoras',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Atividades Integradoras',
                arquivos: [
                    {
                        nome: 'At_Integ1_LP_digital_ApoioCultural',
                        arquivo: 'Materiais/At_Integ1_LP_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'At_Integ2_Matematica_PF',
                        arquivo: 'anexo_storage_files_1684168198464341119.pdf_2025-04-29-1745951935258.pdf',
                    },
                    {
                        nome: 'At_Integ3_Ciencias_digital_ApoioCultural',
                        arquivo: 'Materiais/At_Integ3_Ciencias_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'At_Integ4_Arte_digital_ApoioCultural',
                        arquivo: 'Materiais/At_Integ4_Arte_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'At_Integ5_LinguagemCorporal_digital_ApoioCultural',
                        arquivo: 'Materiais/At_Integ5_LinguagemCorporal_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'At_Integ6_Etica_e_Cidadania_digital_ApoioCultural',
                        arquivo: 'Materiais/At_Integ6_Etica_e_Cidadania_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'At_Integ7_Historia_Geografia_digital_ApoioCultural',
                        arquivo: 'Materiais/At_Integ7_Historia_Geografia_digital_ApoioCultural.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Sequências Didáticas',
        materiais: [
            {
                titlePaste: 'Brincadeiras',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_Brincadeiras_1ano_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_Brincadeiras_1ano_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'SD_Brincadeiras_2ano_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_Brincadeiras_2ano_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'SD_Brincadeiras_3ano_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_Brincadeiras_3ano_digital_ApoioCultural.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Ciências da Natureza',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_CienNat_1oAno_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_CienNat_1oAno_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'SD_CienNat_2oAno_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_CienNat_2oAno_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'SD_CienNat_3oAno_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_CienNat_3oAno_digital_ApoioCultural.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Humanas',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_CienHumanas_1oAno_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_CienHumanas_1oAno_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'SD_CienHumanas_2oAno_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_CienHumanas_2oAno_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'SD_CienHumanas_3oAno_digital_ApoioCultural',
                        arquivo: 'Materiais/SD_CienHumanas_3oAno_digital_ApoioCultural.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Matemática',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_Matematica_1ano_PF',
                        arquivo: 'Materiais/anexo_storage_files_8245909180290559225.pdf_2025-04-29-1745952387709.pdf',
                    },
                    {
                        nome: 'SD_Matematica_2ano_PF',
                        arquivo: 'Materiais/anexo_storage_files_5877566130144195355.pdf_2025-04-29-1745952412313.pdf',
                    },
                    {
                        nome: 'SD_Matematica_3ano_PF',
                        arquivo: 'Materiais/anexo_storage_files_16068587510144470666.pdf_2025-04-29-1745952438461.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Cadernos de Formação',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Alfabetização',
                arquivos: [
                    {
                        nome: 'CadForm_AlfaInicial_agenda1_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda1_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_AlfaInicial_agenda2_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda2_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_AlfaInicial_agenda3_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda3_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_AlfaInicial_agenda4_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda4_digital_ApoioCultural.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Letramento Científico',
                arquivos: [
                    {
                        nome: 'CadForm_LetraCient_agenda1_digi_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LetraCient_agenda1_digi_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_LetraCient_agenda2_dig_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LetraCient_agenda2_dig_ApoioCultural.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Língua Portuguesa',
                arquivos: [
                    {
                        nome: 'CadForm_LP_agenda1_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LP_agenda1_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_LP_agenda2_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LP_agenda2_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_LP_agenda3_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LP_agenda3_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_LP_agenda4_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LP_agenda4_digital_ApoioCultural.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Linguagem Artística',
                arquivos: [
                    {
                        nome: 'CadForm_LingArtistica_agenda1_digi_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LingArtistica_agenda1_digi_ApoioCultural.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Linguagem Corporal',
                arquivos: [
                    {
                        nome: 'CadForm_LingCorporal_agenda1_digi_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LingCorporal_agenda1_digi_ApoioCultural.pdf',
                    },
                    {
                        nome: 'CadForm_LingCorporal_agenda2_digital_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LingCorporal_agenda2_digital_ApoioCultural.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Linguagem Digital',
                arquivos: [
                    {
                        nome: 'CadForm_LingDigital_agenda_digi_ApoioCultural',
                        arquivo: 'Materiais/CadForm_LingDigital_agenda_digi_ApoioCultural.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Matemática',
                arquivos: [
                    {
                        nome: 'CadForm_Matematica_agenda1_PF',
                        arquivo: 'anexo_storage_files_7912864942235882513.pdf_2025-04-29-1745952944871.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda2_PF',
                        arquivo: 'anexo_storage_files_13970242890222051343.pdf_2025-04-29-1745952976777.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda3_PF',
                        arquivo: 'anexo_storage_files_18342518673083674182.pdf_2025-04-29-1745953006278.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda4_PF',
                        arquivo: 'anexo_storage_files_1617181722861019507.pdf_2025-04-29-1745953020981.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Fascículos',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Fascículos',
                arquivos: [
                    {
                        nome: 'Fasc1_Circuito360_ApreGeral_digital_ApoioCultural',
                        arquivo: 'Materiais/Fasc1_Circuito360_ApreGeral_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'Fasc2_Circuito360_digital_ApoioCultural',
                        arquivo: 'Materiais/Fasc2_Circuito360_digital_ApoioCultural.pdf',
                    },
                    {
                        nome: 'Fasc3_Circuito360_digital_ApoioCultural',
                        arquivo: 'Materiais/Fasc3_Circuito360_digital_ApoioCultural.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Guia de Experimento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'GuiaExperimento_Circuito 360_dig_ApoioCultural',
                        arquivo: 'Materiais/GuiaExperimento_Circuito 360_dig_ApoioCultural.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Guia de Implantação e Implementação',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Circuito360_Guia_implantImplem_ApoioCultural',
                        arquivo: 'anexo_storage_files_9243663877397601660.pdf_2025-04-29-1745953225804.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Sistemática de Acompanhamento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'SistAcompanhamento_Circuito 360_digital_ApoioCultural',
                        arquivo: 'Materiais/SistAcompanhamento_Circuito 360_digital_ApoioCultural.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Teste Diagnóstico',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Teste Diagnóstico',
                arquivos: [
                    {
                        nome: 'TesteDiagnostico_LP_aluno_ApoioCultural',
                        arquivo: 'Materiais/TesteDiagnostico_LP_aluno_ApoioCultural.pdf',
                    },
                    {
                        nome: 'TesteDiagnostico_LP_orientacoes_ApoioCultural',
                        arquivo: 'Materiais/TesteDiagnostico_LP_orientacoes_ApoioCultural.pdf',
                    },
                    {
                        nome: 'TesteDiagnostico_MAT_aluno_PF',
                        arquivo: 'anexo_storage_files_4534959763274315354.pdf_2025-04-29-1745953398504.pdf',
                    },
                    {
                        nome: 'TesteDiagnostico_MAT_orientacoes_PF',
                        arquivo: 'anexo_storage_files_10832531026402277856.pdf_2025-04-29-1745953454629.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Textos para Estudo',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Anexos_textos_Circuito360_Ciclo1_dig_ApoioCultural',
                        arquivo: 'Materiais/Anexos_textos_Circuito360_Ciclo1_dig_ApoioCultural.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Modelo Formativo',
        materiais: [
            {
                arquivos: [
                    {
                        nome: '',
                        arquivo: 'Materiais/Modelo_Formativo_Circuito_360_PF_ApoioCultural.pptx',
                    },
                ],
            },
        ],
    },
    {
        title: 'Tabelas e cartazes',
        materiais: [
            {
                titlePaste: 'Tabelas e cartazes',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'Cartazes_Circuito 360_A3_PF',
                        arquivo: 'anexo_storage_files_7029779500207570813.pdf_2025-04-29-1745953683925.pdf',
                    },
                    {
                        nome: 'Tabelas_Circuito_360_A4_PF',
                        arquivo: 'anexo_storage_files_17778891098451391956.pdf_2025-04-29-1745953709186.pdf',
                    },
                ],
            },
        ],
    },
];

export const ListMateriaisCircuitoPrivatePlanoAnual: TItem[] = [
    {
        title: 'Materiais Formativos',
        materiais: [
            {
                titlePaste: '',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'Ciclo_1_agenda_formativa Circuito 360_digital_PlanoAnual',
                        arquivo: 'Materiais/Ciclo_1_agenda_formativa Circuito 360_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'Ciclo_2_agenda_formativa_Circuito360_digital_PlanoAnual',
                        arquivo: 'Materiais/Ciclo_2_agenda_formativa_Circuito360_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'Ciclo_3_agenda_formativa_Circuito_360_digital_PlanoAnual',
                        arquivo: 'Materiais/Ciclo_3_agenda_formativa_Circuito_360_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'Ciclo_4_agenda_formativa_Circuito_360_digital_PlanoAnual',
                        arquivo: 'Materiais/Ciclo_4_agenda_formativa_Circuito_360_digital_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Ciclos Formativos',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'PPT_Circuito_360_Ciclo_1_DIA_1_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_1_DIA_1_PlanoAnual.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_1_DIA_2_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_1_DIA_2_PlanoAnual.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_2_DIA_1_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_2_DIA_1_PlanoAnual.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_2_DIA 2_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_2_DIA 2_PlanoAnual.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_3_DIA_1_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_3_DIA_1_PlanoAnual.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_3_DIA 2_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_3_DIA 2_PlanoAnual.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_4_DIA_1_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_4_DIA_1_PlanoAnual.pptx',
                    },
                    {
                        nome: 'PPT_Circuito_360_Ciclo_4_DIA_2_PlanoAnual',
                        arquivo: 'Materiais/PPT_Circuito_360_Ciclo_4_DIA_2_PlanoAnual.pptx',
                    },
                ],
            },
        ],
    },
    {
        title: 'Atividades Integradoras',
        materiais: [
            {
                titlePaste: '',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'At_Integ1_LP_digital_PlanoAnual',
                        arquivo: 'Materiais/At_Integ1_LP_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'At_Integ2_Matematica_PF',
                        arquivo: 'anexo_storage_files_9883653628171737225.pdf_2025-04-29-1745954394727.pdf',
                    },
                    {
                        nome: 'At_Integ3_Ciencias_digital_PlanoAnual',
                        arquivo: 'Materiais/At_Integ3_Ciencias_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'At_Integ4_Arte_digital_PlanoAnual',
                        arquivo: 'Materiais/At_Integ4_Arte_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'At_Integ5_LinguagemCorporal_digital_PlanoAnual',
                        arquivo: 'Materiais/At_Integ5_LinguagemCorporal_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'At_Integ6_Etica_e_Cidadania_digital_PlanoAnual',
                        arquivo: 'Materiais/At_Integ6_Etica_e_Cidadania_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'At_Integ7_Historia_Geografia_digital_PlanoAnual',
                        arquivo: 'Materiais/At_Integ7_Historia_Geografia_digital_PlanoAnual.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Sequências Didáticas',
        materiais: [
            {
                titlePaste: 'Brincadeiras',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_Brincadeiras_1ano_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_Brincadeiras_1ano_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'SD_Brincadeiras_2ano_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_Brincadeiras_2ano_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'SD_Brincadeiras_3ano_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_Brincadeiras_3ano_digital_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Ciências da Natureza',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_CienNat_1oAno_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_CienNat_1oAno_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'SD_CienNat_2oAno_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_CienNat_2oAno_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'SD_CienNat_3oAno_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_CienNat_3oAno_digital_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Ciências Humanas',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_CienHumanas_1oAno_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_CienHumanas_1oAno_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'SD_CienHumanas_2oAno_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_CienHumanas_2oAno_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'SD_CienHumanas_3oAno_digital_PlanoAnual',
                        arquivo: 'Materiais/SD_CienHumanas_3oAno_digital_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Matemática',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'SD_Matematica_1ano_PF',
                        arquivo: 'Materiais/anexo_storage_files_8245909180290559225.pdf_2025-04-29-1745952387709.pdf',
                    },
                    {
                        nome: 'SD_Matematica_2ano_PF',
                        arquivo: 'Materiais/anexo_storage_files_5877566130144195355.pdf_2025-04-29-1745952412313.pdf',
                    },
                    {
                        nome: 'SD_Matematica_3ano_PF',
                        arquivo: 'Materiais/anexo_storage_files_16068587510144470666.pdf_2025-04-29-1745952438461.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Cadernos de Formação',
        materiais: [
            {
                titlePaste: 'Alfabetização',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'CadForm_AlfaInicial_agenda1_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda1_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_AlfaInicial_agenda2_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda2_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_AlfaInicial_agenda3_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda3_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_AlfaInicial_agenda4_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_AlfaInicial_agenda4_digital_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Letramento Científico',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'CadForm_LetraCient_agenda1_digi_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LetraCient_agenda1_digi_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_LetraCient_agenda2_dig_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LetraCient_agenda2_dig_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Língua Portuguesa',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'CadForm_LP_agenda1_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LP_agenda1_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_LP_agenda2_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LP_agenda2_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_LP_agenda3_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LP_agenda3_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_LP_agenda4_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LP_agenda4_digital_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Linguagem Artística',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'CadForm_LingArtistica_agenda1_digi_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LingArtistica_agenda1_digi_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Linguagem Corporal',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'CadForm_LingCorporal_agenda1_digi_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LingCorporal_agenda1_digi_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_LingCorporal_agenda2_digital_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LingCorporal_agenda2_digital_PlanoAnual.pdf',
                    },
                ],
            },
            {
                titlePaste: 'Linguagem Digital',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'CadForm_LingDigital_agenda_digi_PlanoAnual',
                        arquivo: 'Materiais/CadForm_LingDigital_agenda_digi_PlanoAnual.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Matemática',
                arquivos: [
                    {
                        nome: 'CadForm_Matematica_agenda1_PF',
                        arquivo: 'anexo_storage_files_7912864942235882513.pdf_2025-04-29-1745952944871.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda2_PF',
                        arquivo: 'anexo_storage_files_13970242890222051343.pdf_2025-04-29-1745952976777.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda3_PF',
                        arquivo: 'anexo_storage_files_18342518673083674182.pdf_2025-04-29-1745953006278.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda4_PF',
                        arquivo: 'anexo_storage_files_1617181722861019507.pdf_2025-04-29-1745953020981.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Fascículos',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Fascículos',
                arquivos: [
                    {
                        nome: 'Fasc1_Circuito360_ApreGeral_digital_PlanoAnual',
                        arquivo: 'Materiais/Fasc1_Circuito360_ApreGeral_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'Fasc2_Circuito360_digital_PlanoAnual',
                        arquivo: 'Materiais/Fasc2_Circuito360_digital_PlanoAnual.pdf',
                    },
                    {
                        nome: 'Fasc3_Circuito360_digital_PlanoAnual',
                        arquivo: 'Materiais/Fasc3_Circuito360_digital_PlanoAnual.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Guia de Experimento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'GuiaExperimento_Circuito 360_dig_PlanoAnual',
                        arquivo: 'Materiais/GuiaExperimento_Circuito 360_dig_PlanoAnual.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Guia de Implantação e Implementação',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Circuito360_Guia_implantImplem_PlanoAnual',
                        arquivo: 'Materiais/Circuito360_Guia_implantImplem_PlanoAnual.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Sistemática de Acompanhamento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'SistAcompanhamento_Circuito_360_digital_PlanoAnual',
                        arquivo: 'Materiais/SistAcompanhamento_Circuito_360_digital_PlanoAnual.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Teste Diagnóstico',
        materiais: [
            {
                titlePaste: 'Teste Diagnóstico',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'TesteDiagnostico_LP_aluno_PlanoAnual',
                        arquivo: 'Materiais/TesteDiagnostico_LP_aluno_PlanoAnual.pdf',
                    },
                    {
                        nome: 'TesteDiagnostico_LP_orientacoes_PlanoAnual',
                        arquivo: 'Materiais/TesteDiagnostico_LP_orientacoes_PlanoAnual.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda4_PF',
                        arquivo: 'anexo_storage_files_1617181722861019507.pdf_2025-04-29-1745953020981.pdf',
                    },
                    {
                        nome: 'TesteDiagnostico_MAT_orientacoes_PF',
                        arquivo: 'anexo_storage_files_10832531026402277856.pdf_2025-04-29-1745953454629.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Textos para Estudo',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Anexos_textos_Circuito360_Ciclo1_dig_PlanoAnual',
                        arquivo: 'Materiais/Anexos_textos_Circuito360_Ciclo1_dig_PlanoAnual.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Modelo Formativo',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Modelo_Formativo_Circuito_360_PF_PlanoAnual',
                        arquivo: 'Materiais/Modelo_Formativo_Circuito_360_PF_PlanoAnual.pptx',
                    },
                ],
            },
        ],
    },
    {
        title: 'Cartazes e tabelas',
        materiais: [
            {
                titlePaste: 'Tabelas e cartazes',
                isPaste: true,
                arquivos: [
                    {
                        nome: 'Cartazes_Circuito 360_A3_PF',
                        arquivo: 'anexo_storage_files_7029779500207570813.pdf_2025-04-29-1745953683925.pdf',
                    },
                    {
                        nome: 'Tabelas_Circuito_360_A4_PF',
                        arquivo: 'anexo_storage_files_17778891098451391956.pdf_2025-04-29-1745953709186.pdf',
                    },
                ],
            },
        ],
    },
];
